import { c as _c } from "react/compiler-runtime";
import { Grid } from "@mui-wrapper";
import { CONTENT_MAX_WIDTH, PAGE_X_PADDING } from "@styles/common-styles";
import { Outlet } from "react-router-dom";
/** The default layout of the body of sphere dashboard */
export function DefaultBodyLayout(t0) {
  const $ = _c(10);
  const {
    contentBackgroundColor,
    children
  } = t0;
  let t1;
  if ($[0] !== contentBackgroundColor) {
    t1 = {
      width: "100%",
      px: PAGE_X_PADDING,
      pb: "30px",
      backgroundColor: contentBackgroundColor,
      justifyContent: "center"
    };
    $[0] = contentBackgroundColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "100%",
      maxWidth: CONTENT_MAX_WIDTH
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = children ? children : <Outlet />;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <Grid data-testid="CONTENT" sx={t2}>{t3}</Grid>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <Grid container={true} data-testid="CONTENT_WRAPPER" sx={t1}>{t4}</Grid>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}